import React from "react";
import { USER_SEARCH_FORM_LIMIT } from "../../constants/picker-entries-constants";
import i18n from "../../constants/i18n";
import getUserStore from "../../stores/user-store";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import Et3Picker from "../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../TypesNEW";

const UserSearchLimit = withLiteObserverAndTheme<{ withLimit: boolean }>(
  (props) => {
    const { withLimit } = props;

    return withLimit ? (
      <React.Fragment>
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("LIMIT")}
          options={USER_SEARCH_FORM_LIMIT}
          value={getUserStore().selectedLimitInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getUserStore().selectedLimitInput.set(value);
          }}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </React.Fragment>
    ) : null;
  }
);
export default UserSearchLimit;
